import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { USER_ROUTES as USER_ROUTE_CONSTANTS } from '../../route-constants';

const Profile = lazy(() => import('@~/screens/profile'));
const Account = lazy(() => import('@~/pages/account'));

export const USER_ROUTES: RouteObject[] = [
  {
    path: USER_ROUTE_CONSTANTS.PROFILE.PATH,
    element: <Profile />,
    handle: {
      pageName: USER_ROUTE_CONSTANTS.PROFILE.NAME,
    },
  },
  {
    path: USER_ROUTE_CONSTANTS.ACCOUNT.PATH,
    element: <Account />,
    handle: {
      pageName: USER_ROUTE_CONSTANTS.ACCOUNT.NAME,
    },
  },
];
